import * as React from 'react';
import { Button } from '../button/Button';
import { ButtonVariant } from '../button/Shared';
import { iconName } from '../icons/Icons';
import { Flex } from './FlexHelpers';


export type ToolBarButtonProps = {
    disabled?: boolean,
    icon:iconName,
    onClick?:() => void,
    tooltip:string,
    tooltipHorizontalAlignment?: 'left' | 'right',
    variant?: ButtonVariant

}

export function ToolBarButton(props:ToolBarButtonProps):JSX.Element
{
    return (
        <Button 
            icon={props.icon} 
            variant={props.variant} 
            toolTipText={props.tooltip}
            tooltipHorizontalAlignment={props.tooltipHorizontalAlignment}
            onClick={props.onClick} 
            disabled={props.disabled} />
    );
}

type ToolBarContainerProps = {
    children:React.ReactNode
}

export function ToolBarContainer(props:ToolBarContainerProps):JSX.Element
{
    return (
        <Flex flexDirection="row" alignItems='center'>
            {props.children}
        </Flex>
    );
}